var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8693_20514",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8693_20514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.87191 13C2.53514 13 2.25008 12.8833 2.01675 12.65C1.78341 12.4167 1.66675 12.1316 1.66675 11.7948V4.20517C1.66675 3.86839 1.78341 3.58333 2.01675 3.35C2.25008 3.11667 2.53514 3 2.87191 3H13.1282C13.465 3 13.7501 3.11667 13.9834 3.35C14.2167 3.58333 14.3334 3.86839 14.3334 4.20517V11.7948C14.3334 12.1316 14.2167 12.4167 13.9834 12.65C13.7501 12.8833 13.465 13 13.1282 13H2.87191ZM8.00008 8.37183L2.66675 4.9615V11.7948C2.66675 11.8547 2.68597 11.9039 2.72441 11.9423C2.76286 11.9808 2.81203 12 2.87191 12H13.1282C13.1881 12 13.2373 11.9808 13.2757 11.9423C13.3142 11.9039 13.3334 11.8547 13.3334 11.7948V4.9615L8.00008 8.37183ZM8.00008 7.33333L13.2309 4H2.76925L8.00008 7.33333ZM2.66675 4.9615V4V11.7948C2.66675 11.8547 2.68597 11.9039 2.72441 11.9423C2.76286 11.9808 2.81203 12 2.87191 12H2.66675V4.9615Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.2d68c91937852a4d7da10f2632e70055.svg";
export { ForwardRef as ReactComponent };